import React from "react";
import { motion } from "framer-motion";
import { NUMBERS, ASSETS } from "@/data/content";
import { stagger, fadeUp } from "@/lib/reveal";

export const Numbers = () => (
 <section id="numbers" data-testid="numbers" className="grain relative overflow-hidden bg-forest py-24 md:py-32">
 {/* solid, readable ground, no green-on-green */}
 <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(120%_90%_at_15%_0%,rgba(255,255,255,0.06),transparent_60%)]" />
 <div className="pointer-events-none absolute -bottom-24 -right-16 h-96 w-96 rounded-full bg-carbon/10 blur-3xl" />

 <div className="relative z-[2] mx-auto max-w-[1400px] px-5 md:px-10">
 <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
 className="flex items-start justify-between gap-6">
 <div>
 <span className="font-body text-xs uppercase tracking-[0.3em] text-ochre">The Numbers</span>
 <h2 className="mt-3 max-w-3xl font-display text-4xl font-medium text-cream sm:text-5xl lg:text-6xl">
 One edition. A national record.
 </h2>
 </div>
 <div className="hidden shrink-0 items-center gap-6 md:flex">
 <div className="h-24 w-24 overflow-hidden lg:h-28 lg:w-28"><img src={ASSETS.nradLogo} alt="NRAD Almanac" className="h-full w-full object-cover" /></div>
 <div className="h-24 w-24 overflow-hidden lg:h-28 lg:w-28"><img src={ASSETS.carbon8Round} alt="Carbon8" className="h-full w-full object-cover" /></div>
 <div className="h-24 w-24 overflow-hidden lg:h-28 lg:w-28"><img src={ASSETS.vrgBadge} alt="Verified RegenGrown" className="h-full w-full object-cover" /></div>
 </div>
 </motion.div>

 <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }}
 className="mt-16 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
 {NUMBERS.map((n) => (
 <motion.div key={n.label} variants={fadeUp} className="border-t border-ochre/40 pt-6">
 <div className="font-display text-6xl font-medium text-ochre md:text-7xl">{n.value}</div>
 <p className="mt-3 max-w-xs font-body text-sm leading-relaxed text-cream/85">{n.label}</p>
 </motion.div>
 ))}
 </motion.div>
 </div>
 </section>
);
